import React, { useEffect, useState } from "react";
import { Modal, Select, Tooltip, message } from "antd";
import { InfoCircleFilled } from "@ant-design/icons";
import { apiGetSwitchTicketList } from "api/api";
import dayjs from "dayjs";

// 導出檢查函數供父組件使用
export const checkAvailableTickets = async (recordId) => {
  try {
    const res = await apiGetSwitchTicketList(recordId);
    console.log("獲取換票場次結果:", res);

    if (
      res &&
      res?.data?.content &&
      Array.isArray(res?.data?.content) &&
      res?.data?.content.length > 0
    ) {
      return true; // 有可換票場次
    } else {
      if (res?.errorCode === 403010) {
        message.warning("無法退款申請或者換票");
      } else {
        message.warning("目前沒有可換票的場次");
      }
      return false; // 沒有可換票場次
    }
  } catch (error) {
    console.error("獲取換票場次失敗:", error);
    message.error("獲取換票場次失敗，請稍後再試");
    return false;
  }
};

const ExchangeTicketModal = ({
  isModalOpen,
  handleCancel,
  handleExchangeTicketOk,
  record,
}) => {
  const [selectedValue, setSelectedValue] = useState(null);
  const [ticketsData, setTicketsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (!isModalOpen) return;
      setIsLoading(true);
      try {
        const res = await apiGetSwitchTicketList(record.id);

        if (
          res?.data?.content &&
          Array.isArray(res.data.content) &&
          res.data.content.length > 0
        ) {
          const options = res.data.content.map((item) => ({
            value: item.details[0].id,
            label: (
              <Tooltip
                title={`${item.title} | ${dayjs
                  .unix(item.details[0].startDateTime)
                  .format("YYYY-MM-DD HH:mm:ss")} - ${dayjs
                  .unix(item.details[0].endDateTime)
                  .format("YYYY-MM-DD HH:mm:ss")}${item.details[0].title}`}
              >
                <div
                  style={{
                    maxWidth: 200,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.details[0].title}
                </div>
              </Tooltip>
            ),
          }));
          setTicketsData(options);
        } else {
          setTicketsData([]);
        }
      } catch (error) {
        console.error("API 請求失敗:", error);
        message.error("獲取換票場次失敗，請稍後再試");
        setTicketsData([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [isModalOpen, record?.id]);

  const handleSelectChange = (value) => {
    setSelectedValue(value);
    console.log("選擇的場次:", value);
  };

  const handleOk = () => {
    if (!selectedValue) {
      message.warning("請先選擇要換票的場次");
      return;
    }

    // 將選擇的值和record一起傳遞給父組件
    handleExchangeTicketOk({
      selectedSession: selectedValue,
      originalRecord: record,
    });

    // 重置選擇
    setSelectedValue(null);
  };

  const handleModalCancel = () => {
    setSelectedValue(null);
    handleCancel();
  };

  return (
    <Modal
      title={
        <>
          請點擊您要兌換的場次
          <Tooltip
            title="請注意，只能兌換同等價位的票券。"
            className="ml-1 text-gray-400"
          >
            <InfoCircleFilled />
          </Tooltip>
        </>
      }
      open={isModalOpen}
      onCancel={handleModalCancel}
      okText="確認換票"
      cancelText="取消"
      onOk={handleOk}
      okButtonProps={{ disabled: !selectedValue }}
    >
      <div className="mb-4">
        <p className="text-gray-600 mb-2">
          目前票券：{record?.title} - {record?.name}
        </p>
      </div>

      <Select
        style={{ width: "100%" }}
        placeholder="請選擇要換票的場次"
        options={ticketsData}
        onChange={handleSelectChange}
        value={selectedValue}
        size="large"
        loading={isLoading}
      />
    </Modal>
  );
};

export default ExchangeTicketModal;
